<script lang="ts">
    import { gotoWithLogin } from "../../helper"
    import { _ } from "svelte-i18n"
    import { initialLocale } from "../../i18n"
</script>

<div id="headerpic">
    <img src="assets/img/renz-einfo-headerpic1.jpg" alt="" />
    <div class="text">
        <h1>RENZ eInfo</h1>
    </div>
</div>

<section id="startboxen">
    <div class="container_wide">
        <div class="startboxen_inner">
            <div class="item">
                <div class="text">
                    <div class="icon">
                        <img src="assets/img/icons/calendar.png" alt="" />
                    </div>
                    <h2>{$_("header.processInformationSystem")}</h2>
                </div>
                <a href="/{initialLocale}/operations?type=1" class="more" use:gotoWithLogin>{$_("header.more")}</a>
            </div>
        </div>
    </div>
</section>
